import { useGetPickRatesQuery } from 'common/api/endpoints/harvestData';
import { useGetScheduledPickByIdQuery } from 'common/api/endpoints/schedule';
import { handleError } from 'common/api/utils/handleError';
import { WithLoadingOverlay } from 'common/components/LoadingSpinner';
import { FC, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Constants } from 'utils/constants';
import { PickDataWizard } from '../components/PickDataWizard/PickDataWizard';

export const PickDataWizardView: FC = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const { data, isFetching, error } = useGetScheduledPickByIdQuery({
    id: parseInt(id, 10),
  });
  const {
    data: rates,
    isFetching: isFetchingRates,
    error: ratesError,
  } = useGetPickRatesQuery();

  useEffect(() => {
    if (error) {
      handleError(error, 'Unable to load scheduled pick data.');
      history.replace(`${Constants.routes.PICK_SCHEDULE}/${id}`);
    }
    if (ratesError) {
      handleError(ratesError, 'Unable to load default pick rates.');
    }
  }, [error, history, id, ratesError]);

  return (
    <WithLoadingOverlay isLoading={isFetching || isFetchingRates}>
      {data && <PickDataWizard scheduledPick={data} pickRates={rates} />}
    </WithLoadingOverlay>
  );
};
